module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "days"
  }, [_vm._l((_vm.days), function(day, index) {
    return _c('div', {
      staticClass: "day",
      class: {
        'gray': index % 2 === 0, 'is-today': day.is_today === true
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(day.date, 'dd. Do MMM ')))]), _c('div', {
      staticClass: "events"
    }, _vm._l((day.events), function(event) {
      return _c('div', {
        staticClass: "event"
      }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
    }), 0), (day.production_managers.length > 0) ? _c('div', {
      staticClass: "production-managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("PL:  ")]), _vm._l((day.production_managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), (day.day_managers.length > 0) ? _c('div', {
      staticClass: "day-managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("TL:  ")]), _vm._l((day.day_managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), (day.managers.length > 0) ? _c('div', {
      staticClass: "managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("AL:  ")]), _vm._l((day.managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), _vm._l((day.my_shifts), function(shift, index) {
      return _c('shift', {
        key: shift.id,
        class: {
          'gray': index % 2 === 0
        },
        attrs: {
          "shift": shift
        }
      })
    }), (day.other_shifts.length > 0 || day.documents.length > 0 || (day.schedule && day.schedule !== '')) ? _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "button-div"
    }, [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.toggleOtherShifts(day)
        }
      }
    }, [_vm._v("Tagesübersicht")])]), (day.schedule && day.schedule !== '') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (day.show_others),
        expression: "day.show_others"
      }],
      staticClass: "schedule"
    }, [_c('h3', [_vm._v("Tagesablauf")]), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreaks(day.schedule))
      }
    })]) : _vm._e(), (day.documents.length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (day.show_others),
        expression: "day.show_others"
      }],
      staticClass: "documents"
    }, [_c('h3', [_vm._v("Dokumente")]), _c('ul', {
      staticClass: "files"
    }, _vm._l((day.documents), function(doc) {
      return _c('li', [_c('a', {
        attrs: {
          "href": doc.url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa",
        class: doc.icon
      }), _vm._v(" " + _vm._s(doc.name))])])
    }), 0)]) : _vm._e(), (day.show_others) ? _c('div', {
      staticClass: "other-shifts"
    }, _vm._l((day.other_shifts), function(shift, index) {
      return _c('shift', {
        key: shift.id,
        class: {
          'gray': index % 2 === 0
        },
        attrs: {
          "shift": shift
        }
      })
    }), 1) : _vm._e()]) : _vm._e()], 2)
  }), (_vm.days.length == 0) ? _c('div', [_c('br'), _c('br'), _c('span', [_vm._v("Du bist aktuell keiner Schicht zugeteilt!")]), _c('br'), _c('br'), (_vm.user.can_apply_for_shifts) ? _c('span', [_vm._v("Checke Deine")]) : _vm._e(), _c('br')]) : _vm._e(), (_vm.user.can_apply_for_shifts) ? _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.switchToApplications()
      }
    }
  }, [_vm._v("Bewerbungen")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c58447"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shifts.vue
// module id = 1080
// module chunks = 1